import { render, staticRenderFns } from "./PlanList.vue?vue&type=template&id=0d1d2c5c&scoped=true"
import script from "./PlanList.vue?vue&type=script&lang=js"
export * from "./PlanList.vue?vue&type=script&lang=js"
import style0 from "./PlanList.vue?vue&type=style&index=0&id=0d1d2c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1d2c5c",
  null
  
)

export default component.exports